function calculateScrollbarWidth() {
	document.documentElement.style.setProperty(
		"--root-scrollbar-width",
		window.innerWidth - document.documentElement.clientWidth + "px"
	);
}
window.addEventListener("resize", calculateScrollbarWidth, false);

calculateScrollbarWidth();



// WEBPACK FOOTER //
// ./project/client/src/core/components/scrollbar-width/scrollbar-width.js